<template>
  <!--Camera Function! -->
  <div class="cam-note">
    <!--<p>Location: {{ GeoPoint.latitude }}, {{ GeoPoint.longitude }}</p>
    <div v-show="!picTaken" class="cam-frame">
      <video id="video" ref="video" autoplay />
    </div>
    <div v-show="picTaken" class="cam-frame">
      <canvas id="canvas" ref="canvas" />
    </div>
    <el-button v-show="!picTaken" icon="el-icon-camera" circle @click="capture()" />
    <el-button v-show="picTaken" icon="el-icon-camera-solid" circle @click="retake()" />
    <div>-->
    <form @submit.prevent="sendNote">
      <div id="image-box">
        <label class="label">
          <i id="noteCam-icon-cam" class="el-icon-camera-solid" />
          <input id="file-input" type="file" accept="image/*" @change="onCaptured">
          <img v-show="uploadedImage" id="thumnail" :src="uploadedImage">
        </label>
      </div>
      <div class="field">
        <label class="label">Title</label>
        <div class="control">
          <el-input v-model="title" class="note-inputField" placeholder="Title" required />
        </div>
      </div>

      <div class="field">
        <label class="label">What does it meant to you?</label>
        <div class="control">
          <el-input
            v-model="description"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10}"
            placeholder="Please input"
            class="note-inputField"
            required
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Category</label>
        <div class="control">
          <el-select 
            v-model="category"
            multiple
            placeholder="Select" 
            filterable
            allow-create
            default-first-optionclass="note-inputField" required
          >
            <el-option
              v-for="item in categories"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>

      <div v-if="deadline" class="field">
        <label class="label">When do you finish?</label>
        <div class="control">
          <el-date-picker
            id="deadline"
            v-model="expDate"
            type="datetime"
            placeholder="いつまで？"
            required
          />
        </div>
      </div>
        

      <div class="field">
        <label class="label">Related Project?</label>
        <div class="control">
          <el-select
            v-model="projectId"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="Please enter a keyword"
            default-first-optionclass="note-inputField" required
          >
            <el-option
              v-for="item in projectInfo.projectDatas"
              :key="item.slug"
              :label="item.projectname"
              :value="item.slug"
            />
          </el-select>
        </div>
      </div>
          
      <div class="field">
        <label class="label">Make it private?</label>
        <div class="control">
          <el-switch v-model="isPrivate" class="note-inputField" />
        </div>
      </div>
      <div id="map" />
      <div class="field">
        <div class="control">
          <button type="submit">
            add note
          </button>
          <p>Location: {{ GeoPoint.latitude }}, {{ GeoPoint.longitude }}</p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import cameraHandler from '@/js/cameraHandler.js';
import noteHandler from '@/js/noteHandler.js';
import { isMobile } from 'mobile-device-detect';
import { mapGetters, mapActions } from 'vuex'; // mapState,
import store from "@/store";
import router from '@/router.js';

export default {
  data(){
    return{
      apiKey: 'AIzaSyCACkyIDLs8rDk7bGHYFvs3IMf2itTCV5A',
      google: null,
      userId: this.$route.params.userId,
      projectId:  null,
      title: null,
      description:  null,
      category: [],
      expDate:  null,
      isPrivate: false,
      video: {},
      canvas: {},
      imageFile: [],
      uploadedImage: '',
      selectedFile: null,
      GeoPoint: {
        latitude: null,
        longitude: null,
      },
      picTaken: false,
      deadline: false,
      screensize: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      vidHeight:null,
      categories: [{
          value: 'inspiration',
          label: 'Inspiration'
        }, {
          value: 'idea',
          label: 'Idea'
        }, {
          value: 'ref',
          label: 'Reference'
        }, {
          value: 'todo',
          label: 'To Do'
        }],
    };
  },
  computed: {
    ...mapGetters(['projectInfo']),
  },
  watch: {
    // この関数は category が変わるごとに実行されます。
    category: function () {
      if (this.category.includes('todo')){
        this.deadline = true;
      }else{
        this.deadline = false;
      }
    }
  },
  // 写真を撮るには３つのサイズを決める必要がある！
  // 1) リアルタイムで映るカメラフレームのサイズを決める
  // 2) 写した画像をレンダリングするキャンバスサイズを決める
  // 3) キャプチャした画像のサイズを決める
  // スクリーンリサイズ検出：https://qiita.com/yuukive/items/ede7c087843d2f7ef979
  // デバイス検出：https://github.com/duskload/mobile-device-detect
  // GeoLocation : https://www.raymondcamden.com/2019/09/01/using-geolocation-with-vuejs

  mounted(){
    this.fetchDatabase(this.$route.params.userId);

    this.video = this.$refs.video;

    // カメラスタート！
    // cameraHandler.startCamera (this.video);

    window.addEventListener('resize', this.handleResize);

    // let canvas = document.getElementById('canvas');
    // let vid = document.getElementById('video');

    if(isMobile){
      if(this.screensize.width>this.screensize.height){
        // canvas.width = this.screensize.width;
        // canvas.height = this.screensize.width/4*3;
        console.log("phone : width is bigger");
      }else{
        // canvas.width = this.screensize.width;
        // canvas.height = this.screensize.height;
        console.log("phone : height is bigger");
      }
    }else{
      // canvas.width = this.screensize.width;
      // canvas.height = this.screensize.width/4*3;
      console.log("laptop : width is bigger");
    }
    // canvas.width = 400;
    // canvas.height = 400;
    // vid.width = this.screen.width;
    // vid.height = this.screen.width/4*3;
    
  },
  methods: {
    ...mapActions(['fetchDatabase','fetchCamShow','fetchTxtShow','fetchMicShow','fetchDrawShow']),
    capture() {
      this.canvas = this.$refs.canvas
      if(isMobile){
        if(this.screensize.width>this.screensize.height){
        this.canvas.getContext('2d').drawImage(this.video, 0, 0,this.screensize.width,this.screensize.width/4*3)
        console.log("captured from phone : width is bigger")
        this.imageFile.push(this.canvas.toDataURL('image/png'))
        }else{
          this.canvas.getContext('2d').drawImage(this.video, 0, 0,this.screensize.width,this.screensize.height)
          console.log("captured from phone : height is bigger")
          this.imageFile.push(this.canvas.toDataURL('image/png')) 
        }
      }else{
        this.canvas.getContext('2d').drawImage(this.video, 0, 0,this.screensize.width,this.screensize.width/4*3)
        console.log("captured from laptop")
        this.imageFile.push(this.canvas.toDataURL('image/png'))
      }
      // let fileInput = document.getElementById('file-input');
      // fileInput = this.imageFile;
      // cameraHandler.pauseCamera (this.video)
      // console.log(this.imageFile)
      this.picTaken = true;
      this.geolocation();

      // cameraHandler.stopCamera(this.video);
      // this.canvas = this.$refs.canvas;
      // var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 640, 480);
      // ここを修正
      // this.captures.push(this.canvas.toDataURL("image/webp"));
      // this.canvas.toBlob((blob) => {
      // {{'Elementコンポーネントのfile-listに割り当てているオブジェクト'}}.push({name: 'camera',
        // status: 'success',
        // url: URL.createObjectURL(blob),
        // raw: blob
      // })
    // })
    },
    onCaptured(event){
      console.log("set image on input-field")
      this.selectedFile = event.target.files[0];
      this.createImage(event.target.files[0]);
      this.geolocation();
    },
    // アップロードした画像を表示
    // https://qiita.com/komatzz/items/f2a25db16aca388845d3
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.uploadedImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    retake(){
      cameraHandler.startCamera (this.video);
      this.imageFile = [];
      this.picTaken = false;
    },
    stopCam(){
      cameraHandler.stopCamera (this.video);
      this.imageFile = [];
    },
    handleResize: function() {
      // resizeのたびにこいつが発火するので、ここでやりたいことをやる
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    sendNote(){
      noteHandler.camNoteUpload(this.userId,this.projectId,this.title,this.description,this.category,this.selectedFile,this.isPrivate,this.GeoPoint);
      store.commit('setCamShow', false);
      store.commit('setTxtShow', false);
      store.commit('setMicShow', false);
      store.commit('setDrawShow', false);
      router.push({ name: 'home', params: { userId: this.userId } });
    },
    geolocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.GeoPoint = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
      });
    },
  },
}
</script>

<style>
  @media screen and (max-width:768px){
    /*画面サイズが480pxからはここを読み込む*/
    #image-box{
      height: 250px;
    }
    #file-input{
      height: 250px;
    }
    #thumnail{
      max-height: 33%;
    }
  }

  @media screen and (min-width:768px) and ( max-width:1024px) {
    /*画面サイズが768pxから1024pxまではここを読み込む*/
    #image-box{
      height: 350px;
    }
    #file-input{
      height: 350px;
    }
    #thumnail{
      max-height: 42%;
    }
  }

  @media screen and (min-width:1024px) {
    /*画面サイズが1024pxからはここを読み込む*/
    #image-box{
      height: 400px;
    }
    #file-input{
      height: 400px;
    }
    #thumnail{
      max-height: 45%;
    }
  }
  .cam-note{
    width: 100%;
  }
  #video{
    width: 100%;
    max-height: 100%;
  }
  #image-box{
    border: solid #d3d3d3 2px;
    background-color:  #ffffff;
    border-radius: 20px;
  }
  #image-box:hover{
    background-color : #ffa060;
  }
  #file-input{
    position: absolute;
    opacity: 0%;
    left: 0;
    width: 100%;
  }
  #thumnail{
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translateY(-0%) translateX(-50%);
  }
  #noteCam-icon-cam{
    position: absolute;
    top: 22%;
    left: 49%;
  }
</style>